
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Layout from '../../../../components/docs/Layout';
import Actions from '../../../../components/docs/Actions';
export const metadata = {
  toc: true,
  title: 'API Reference',
  section: 'API Reference',
  layout: 'reference',
  description: 'Data Definitions, Data Endpoints and Errors'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Libraries = makeShortcode("Libraries");
const Tag = makeShortcode("Tag");
const AlertError = makeShortcode("AlertError");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Header title='API Reference' subtitle='Data Definitions, Data Endpoints and Errors' mdxType="Header" />
    <Actions.Wrapper>
  <Actions.Card icon={<Libraries mdxType="Libraries" />} title='Data Definitions' subtitle='Plaid Exchange data definitions, objects and data types.' link='/plaid-exchange/docs/reference/data-definitions' linkText='Get Started' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='API Reference' subtitle='Reference for building out the Plaid Exchange APIs.' link='/plaid-exchange/docs/reference/aggregation' linkText='Get Started' />
  <Actions.Card icon={<AlertError mdxType="AlertError" />} title='Error Handling' subtitle='Information about handling errors inside Plaid Exchange.' link='/plaid-exchange/docs/reference/errors-and-conditions' linkText='Get Started' />
    </Actions.Wrapper>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
